<template>
  <BaseDraggableModal
      :name="modal_name"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      :ref="modal_name">
    <v-card :loading="loading">
      <BaseModal>
        <div slot="header">
        <v-toolbar class="draggable_selector" dark color="primary" dense flat>
          <v-toolbar-title>{{ page.title }}</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        </div>
        <div slot="content">
          <v-card-text>
            <v-autocomplete
                :label="$store.getters.translate('select_exams')"
                v-model="scheme"
                :items="$lodash.sortBy(schemes, 'name')"
                :return-object="true"
                item-text="name"
                item-value="id"/>
            <div class="text-center">
              <v-progress-circular v-if="loading_exams" :size="50" color="primary" indeterminate class="ma-8"/>
            </div>
            <small v-if="no_exams_found" class="text-muted text-center red--text">
              {{ $store.getters.translate("no_exams") }}
            </small>
            <v-list subheader two-line>
              <v-list-item-group v-model="record.exams" multiple>
                <v-list-item
                    v-for="(exam, index) in exams"
                    :key="index"
                    :value="exam"
                    color="primary"
                    :disabled="registrationClosed(exam)">
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-list-item-title :class="registrationClosed(exam) ? 'grey--text' : null">
                        {{ exam.examination_date }}
                        <span v-if="exam.location"> - {{ exam.location.name }}</span>
                        {{ calcPrice(exam.sessions) }}
                        <small class="red--text" v-if="registrationClosed(exam)">
                          ({{ $store.getters.translate("full") }})
                        </small>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ $lodash.map(exam.sessions, "name").join(", ") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon v-if="!active" color="grey lighten-1">
                        mdi-check-circle-outline
                      </v-icon>
                      <v-icon v-else color="success">
                        mdi-check-circle
                      </v-icon>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <div v-if="scheme && record.exams.length > 0" class="mt-2" v-html="scheme.prerequisites"/>
            <v-checkbox v-if="record.exams.length > 0" v-model="agree" :label="$store.getters.translate('i_agree')"/>
          </v-card-text>
        </div>
        <div slot="footer">
          <v-btn :loading="loading" class="mt-5" color="primary" @click="save" :disabled="canSubmit" block>
            {{ $store.getters.translate("submit_registration") }}
          </v-btn>
        </div>
      </BaseModal>
    </v-card>
  </BaseDraggableModal>
</template>

<script>
import helpFunctions from "../../../../plugins/helpFunctions";
import BaseModal from "../../../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../../../components/commonComponents/BaseDraggableModal";

export default {
  props: ["modal_name", "candidate_id"],
  components: {BaseModal, BaseDraggableModal},
  data() {
    return {
      page: {
        title: this.$store.getters.translate("register_in_exam"),
      },
      record: {
        exams: [],
      },
      loading: false,
      scheme: null,
      exams: [],
      schemes: [],
      no_exams_found: false,
      loading_exams: false,
      agree: false,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    load() {
      this.getSchemes();
    },
    save() {
      if(!this.loading) {
        this.loading = true;
        this.$http
            .post(this.$store.getters.appUrl + "v2/registration", {
              exams: this.$lodash.map(this.record.exams, "id"),
              candidate_id: this.candidate_id,
            })
            .then(() => {
              this.loading = false;
              this.$toasted.success(this.$store.getters.translate("request_received"));
              this.closeModal(this.modal_name);
              this.$emit("refresh");
            })
            .catch((error) => {
              if (this.$store.getters.isLoggedIn) {
                this.$toasted.error(error);
              }
              this.loading = false;
            });
      }
    },
    getExams() {
      this.loading_exams = true;
      this.no_exams_found = false;
      this.$http
          .get(this.$store.getters.appUrl + "v2/published/exams/" + this.scheme.id)
          .then((response) => {
            this.exams = Object.values(response.data);
            if (this.exams.length > 0) {
              this.no_exams_found = false;
            } else {
              this.no_exams_found = true;
            }
            this.loading_exams = false;
          })
          .catch((error) => {
            if (this.$store.getters.isLoggedIn) {
              this.$toasted.error(error);
            }
            this.loading_exams = false;
          });
    },
    getSchemes() {
      this.$http
          .get(this.$store.getters.appUrl + "v2/published/schemes")
          .then((response) => {
            this.schemes = response.data;
          })
          .catch((error) => {
            if (this.$store.getters.isLoggedIn) {
              this.$toasted.error(error);
            }
          });
    },
    calcPrice(sessions) {
      let price = 0;
      sessions.forEach((session) => {
        price = price + session.price;
      });
      if (price == 0) {
        return null;
      }
      return "(€ " + price + ",00 excl. BTW)";
    },
    registrationClosed(exam) {
      let closed = false;
      exam.sessions.forEach((session) => {
        if (session.full) {
          closed = true;
        }
      });
      return closed;
    },
  },
  computed: {
    canSubmit() {
      return !(this.record.exams.length > 0 && this.agree);

    },
  },
  watch: {
    scheme: {
      handler() {
        this.getExams();
      },
    },
  },
};
</script>
